/* ==========================================================================
   BEACH WEEKEND COFFEE - LANDING v3
   Built by SilverSky Drone Photography for Beach Weekend.

   Every price, variant ID and subscription term in here comes from the
   #bwcData blob, which Liquid renders from live Shopify product data.
   Nothing about the offer is hardcoded in this file - if a price changes in
   Shopify, this page changes with it.
   ========================================================================== */
(function () {
  "use strict";

  var root = document.getElementById("bwc");
  var dataEl = document.getElementById("bwcData");
  if (!root || !dataEl) return;

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var ROASTS = DATA.roasts || [];
  if (!ROASTS.length) return;

  var byKey = {};
  ROASTS.forEach(function (r) { byKey[r.key] = r; });

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- money ---------- */
  var fmt = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });
  function money(cents) { return fmt.format((cents || 0) / 100); }
  /* Whole dollars lose the ".00", matching Liquid's money_without_trailing_zeros
     so the shipping sentence reads the same in markup and in script. */
  function moneyShort(cents) {
    var s = money(cents);
    return s.replace(/\.00$/, "");
  }

  /* ---------- variant helpers ---------- */
  var AXES = ["Texture", "Size", "Bag Count"];

  function axisValues(roast, axis) {
    var seen = [], out = [];
    roast.variants.forEach(function (v) {
      var val = v.opts[axis];
      if (val != null && seen.indexOf(val) === -1) { seen.push(val); out.push(val); }
    });
    return out;
  }

  function findVariant(roast, sel) {
    for (var i = 0; i < roast.variants.length; i++) {
      var v = roast.variants[i], ok = true;
      for (var a = 0; a < AXES.length; a++) {
        if (sel[AXES[a]] != null && v.opts[AXES[a]] !== sel[AXES[a]]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* Cheapest single bag - used for the "from" and subscribe copy. */
  function baseVariant(roast) {
    var best = null;
    roast.variants.forEach(function (v) {
      if (!best || v.price < best.price) best = v;
    });
    return best;
  }

  /* Every plan on a variant, in the order the subscription app lists them.
     Dylan controls that order in Appstle, so it is the merchant's own ranking. */
  function plansFor(variant) {
    return (variant && variant.plans) || [];
  }

  /* The plan we lead with. Monthly wins when it exists - it is what most
     households actually want - otherwise the first plan the app lists.
     We deliberately do NOT pick the cheapest: that used to surface Weekly
     only, and Monthly never appeared anywhere on the page. */
  function defaultPlan(variant) {
    var ps = plansFor(variant);
    if (!ps.length) return null;
    for (var i = 0; i < ps.length; i++) {
      if (/month/i.test(ps[i].name)) return ps[i];
    }
    return ps[0];
  }

  function planById(variant, id) {
    var ps = plansFor(variant);
    for (var i = 0; i < ps.length; i++) if (ps[i].id === id) return ps[i];
    return null;
  }

  function savedPct(variant, plan) {
    return Math.round((1 - plan.price / variant.price) * 100);
  }

  /* ---------- stars ---------- */
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 17.3 5.9 20.6l1.4-6.8L2.2 9.1l6.9-.8z"/></svg>';
  root.querySelectorAll(".bw-stars").forEach(function (el) {
    if (!el.innerHTML.trim()) el.innerHTML = STAR.repeat(5);
  });

  /* ---------- scroll reveal ---------- */
  var revealEls = root.querySelectorAll("[data-rv],[data-rv-group],.bw-wave");
  if (!("IntersectionObserver" in window) || reduce) {
    revealEls.forEach(function (el) { el.classList.add("bw-is-in"); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("bw-is-in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -8% 0px" });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  requestAnimationFrame(function () {
    root.querySelectorAll(".bw-hero .bw-rvline").forEach(function (l, i) {
      setTimeout(function () { l.classList.add("bw-is-in"); }, 120 + i * 110);
    });
  });
  root.querySelectorAll(".bw-final .bw-rvline").forEach(function (l) {
    if ("IntersectionObserver" in window && !reduce) {
      new IntersectionObserver(function (en, o) {
        if (en[0].isIntersecting) { l.classList.add("bw-is-in"); o.disconnect(); }
      }, { threshold: 0.5 }).observe(l);
    } else { l.classList.add("bw-is-in"); }
  });

  /* ---------- parallax + buy bar visibility ---------- */
  var pxEls = root.querySelectorAll("[data-px]");
  var buybar = document.getElementById("bwcBuybar");
  var heroEl = root.querySelector(".bw-hero");
  var ticking = false;

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      if (!reduce) {
        pxEls.forEach(function (el) {
          var r = el.parentElement.getBoundingClientRect();
          if (r.bottom > 0 && r.top < window.innerHeight) {
            var off = (r.top - window.innerHeight / 2) * parseFloat(el.dataset.px);
            el.style.transform = "translate3d(0," + off.toFixed(1) + "px,0)";
          }
        });
      }

      if (buybar && heroEl) {
        buybar.classList.toggle("bw-is-on", heroEl.getBoundingClientRect().bottom < 0);
      }
      syncTheatre();
      ticking = false;
    });
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });

  /* ---------- background video: play only while on screen ---------- */
  /* The <video> ships with no src so nothing downloads until the band is
     near the viewport. Reduced-motion, data-saver and 2G/3G users keep the
     still poster. */
  (function () {
    var vids = root.querySelectorAll("[data-bw-video]");
    if (!vids.length) return;
    var conn = navigator.connection || {};
    var saveData = conn.saveData || /(^|-)2g$|^3g$/.test(conn.effectiveType || "");

    function arm(v) {
      if (v.dataset.armed) return;
      v.dataset.armed = "1";
      var hls = v.dataset.srcHls, mp4 = v.dataset.srcMp4;
      /* Safari and iOS play HLS natively and pick a bitrate for the connection;
         everyone else gets the single mp4 rendition Shopify exposes. */
      var useHls = hls && v.canPlayType("application/vnd.apple.mpegurl");
      v.src = useHls ? hls : mp4;
      v.load();
    }
    function ready(v) { v.classList.add("bw-is-ready"); }
    function play(v) {
      arm(v);
      var p = v.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused: poster stays */ });
    }

    vids.forEach(function (v) {
      v.addEventListener("playing", function () { ready(v); });
      v.addEventListener("loadeddata", function () { if (!v.paused) ready(v); });
    });

    if (reduce || saveData || !("IntersectionObserver" in window)) return;

    var vio = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) play(v);
        else if (!v.paused) v.pause();
      });
    }, { rootMargin: "200px 0px", threshold: 0.05 });
    vids.forEach(function (v) { vio.observe(v); });

    /* Warm the file a little before it is needed so the fade-in is clean. */
    var warm = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { arm(e.target); warm.unobserve(e.target); } });
    }, { rootMargin: "600px 0px" });
    vids.forEach(function (v) { warm.observe(v); });

    document.addEventListener("visibilitychange", function () {
      vids.forEach(function (v) {
        if (document.hidden) { if (!v.paused) v.pause(); }
        else if (v.dataset.armed) {
          var r = v.getBoundingClientRect();
          if (r.bottom > 0 && r.top < window.innerHeight) play(v);
        }
      });
    });
  })();

  /* ---------- "watch the full video": poster -> embedded player on tap ---------- */
  (function () {
    var frame = document.getElementById("bwcWatchFrame");
    if (!frame || !frame.dataset.videoId) return;
    var provider = frame.dataset.provider;
    var id = frame.dataset.videoId;
    var started = false;

    function embedUrl() {
      if (provider === "vimeo") {
        return "https://player.vimeo.com/video/" + encodeURIComponent(id) + "?autoplay=1&title=0&byline=0&portrait=0&dnt=1";
      }
      return "https://www.youtube-nocookie.com/embed/" + encodeURIComponent(id) +
        "?autoplay=1&rel=0&modestbranding=1&playsinline=1";
    }

    function start() {
      if (started) return;
      started = true;
      var iframe = document.createElement("iframe");
      iframe.src = embedUrl();
      iframe.title = "Beach Weekend Coffee video";
      iframe.setAttribute("allow", "autoplay; encrypted-media; picture-in-picture; fullscreen");
      iframe.setAttribute("allowfullscreen", "");
      iframe.setAttribute("loading", "eager");
      iframe.className = "bw-watch__iframe";
      frame.classList.add("bw-is-playing");
      frame.appendChild(iframe);
      /* Pause the silent loop above so two videos are not fighting for bandwidth. */
      root.querySelectorAll("[data-bw-video]").forEach(function (v) { if (!v.paused) v.pause(); });
    }

    root.querySelectorAll("[data-bw-watch-play]").forEach(function (b) {
      b.addEventListener("click", start);
    });
    frame.addEventListener("click", function (ev) {
      if (!started && !ev.target.closest("[data-bw-watch-play]")) start();
    });
  })();

  /* ---------- hero bag carousel ---------- */
  /* Crossfades the four roasts behind the headline. Opacity only - the bob
     keyframes live on the wrapper, so nothing fights over transform. Runs only
     while the hero is on screen and the tab is visible; reduced-motion users
     keep the first bag, which is also what shows if this script never runs. */
  (function () {
    var wrap = document.getElementById("bwcHeroBags");
    if (!wrap) return;
    var bags = wrap.querySelectorAll(".bw-hero__bag");
    if (bags.length < 2 || reduce) return;

    var i = 0, timer = null;

    function step() {
      bags[i].classList.remove("bw-is-active");
      i = (i + 1) % bags.length;
      bags[i].classList.add("bw-is-active");
    }
    function start() { if (!timer) timer = setInterval(step, 3800); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function onScreen() {
      var r = wrap.getBoundingClientRect();
      return r.bottom > 0 && r.top < window.innerHeight;
    }

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) start(); else stop();
      }, { threshold: 0.15 }).observe(wrap);
    } else {
      start();
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop();
      else if (onScreen()) start();
    });
  })();

  /* ---------- sticky roast theatre ---------- */
  var detail = document.getElementById("bwcDetail");
  var panels = Array.prototype.slice.call(root.querySelectorAll(".bw-panel"));
  var bags = root.querySelectorAll(".bw-detail__bag");
  var lastPanel = -1;

  panels.forEach(function (p) { p.style.setProperty("--accent", p.dataset.accent); });
  if (detail && panels.length) detail.style.setProperty("--dark", panels[0].dataset.bg);

  function syncTheatre() {
    if (!detail || !panels.length) return;
    var line = window.innerHeight * 0.48, idx = 0;
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].getBoundingClientRect().top <= line) idx = i;
    }
    if (idx === lastPanel) return;
    lastPanel = idx;
    var p = panels[idx];
    bags.forEach(function (b) { b.classList.toggle("bw-is-active", b.dataset.bag === p.dataset.panel); });
    detail.style.setProperty("--dark", p.dataset.bg);
    setBuybar(p.dataset.roast);
  }

  /* ---------- buy bar ---------- */
  var bbImg = document.getElementById("bwcBbImg");
  var bbName = document.getElementById("bwcBbName");
  var bbPrice = document.getElementById("bwcBbPrice");
  var bbSub = document.getElementById("bwcBbSub");
  var bbAdd = document.getElementById("bwcBbAdd");
  var buybarKey = ROASTS[0].key;

  function setBuybar(key) {
    var r = byKey[key];
    if (!r) return;
    buybarKey = key;
    if (bbImg) bbImg.src = r.img;
    if (bbName) bbName.textContent = r.name;
    var bv = baseVariant(r), plan = defaultPlan(bv);
    if (bbPrice) bbPrice.textContent = "From " + money(bv.price);
    if (bbSub) bbSub.textContent = plan ? "or " + money(plan.price) + " subscribed" : "";
  }

  /* Shopify option values are shouty ("16 OZ BAG", "2 BAGS"). Soften them for
     display only - the raw value is still what gets matched against variants. */
  function optLabel(axis, val) {
    var v = String(val);
    if (axis === "Bag Count") return v.replace(/\s*BAGS?$/i, "");
    if (axis === "Size") return v.replace(/\s*BAG$/i, "").replace(/\bOZ\b/i, "oz").replace(/\bLB\b/i, "lb");
    return v;
  }
  setBuybar(buybarKey);
  if (bbAdd) bbAdd.addEventListener("click", function () { openDrawer(buybarKey); });

  /* ---------- subscribe section, driven by the real selling plan ---------- */
  (function () {
    var card = document.getElementById("bwcSubName");
    if (!card) return;

    /* Lead with the first subscribable roast in block order, not the one with
       the deepest discount - otherwise the card silently advertises whichever
       interval happens to be cheapest and buries the rest. */
    var subRoast = null, subPlan = null, subVariant = null;
    for (var i = 0; i < ROASTS.length; i++) {
      var bv = baseVariant(ROASTS[i]), pl = defaultPlan(bv);
      if (pl) { subRoast = ROASTS[i]; subPlan = pl; subVariant = bv; break; }
    }
    if (!subPlan) return;

    var pct = savedPct(subVariant, subPlan);
    document.getElementById("bwcSubFlag").textContent = "Save " + pct + "%";
    card.textContent = subPlan.name;
    document.getElementById("bwcSubPrice").textContent = money(subPlan.price);
    document.getElementById("bwcSubWas").textContent = money(subVariant.price);
    document.getElementById("bwcSubSave").textContent =
      "You save " + money(subVariant.price - subPlan.price) + " every bag";
    document.getElementById("bwcOneOffPrice").textContent = money(subVariant.price);

    var list = document.getElementById("bwcSubList");
    var li = document.createElement("li");
    li.innerHTML = "<span><b>" + pct + "% off every delivery</b> - not just the first one</span>";
    list.insertBefore(li, list.firstChild);

    /* Name every other interval on offer. Without this the card reads as though
       one frequency is all there is. */
    var others = plansFor(subVariant).filter(function (p) { return p.id !== subPlan.id; });
    if (others.length) {
      var alt = document.createElement("li");
      alt.innerHTML = "<span>Also available " +
        others.map(function (p) {
          return "<b>" + p.name.replace(/\s*subscription$/i, "").toLowerCase() +
                 "</b> at " + savedPct(subVariant, p) + "% off";
        }).join(", ") + "</span>";
      list.insertBefore(alt, li.nextSibling);
    }

    document.getElementById("bwcSubCta").addEventListener("click", function () {
      openDrawer(subRoast.key, "sub");
    });
    document.getElementById("bwcOneCta").addEventListener("click", function () {
      openDrawer(subRoast.key, "one");
    });
  })();

  /* ---------- roast finder ---------- */
  (function () {
    var finder = document.getElementById("bwcFinder");
    if (!finder) return;
    var qs = finder.querySelectorAll(".bw-finder__q");
    var result = document.getElementById("bwcFinderResult");
    var answers = {};
    var step = 0;

    function show(i) {
      qs.forEach(function (q, n) { q.classList.toggle("bw-is-on", n === i); });
      result.classList.remove("bw-is-on");
    }

    function score(roast) {
      var s = 0;
      if (answers.brew && (roast.brew === answers.brew || roast.brew === "any")) s += 3;
      if (answers.brew === "espresso" && roast.brew === "espresso") s += 2;
      if (answers.profile && roast.profile === answers.profile) s += 3;
      if (answers.take === "milk" && roast.profile === "classic") s += 2;
      if (answers.take === "black" && roast.profile === "bright") s += 1;
      if (answers.take === "iced" && roast.profile === "balanced") s += 1;
      return s;
    }

    function finish() {
      var best = ROASTS[0], bestScore = -1;
      ROASTS.forEach(function (r) {
        var s = score(r);
        if (s > bestScore) { bestScore = s; best = r; }
      });
      qs.forEach(function (q) { q.classList.remove("bw-is-on"); });
      result.classList.add("bw-is-on");
      document.getElementById("bwcFrImg").src = best.img;
      document.getElementById("bwcFrImg").alt = best.name;
      document.getElementById("bwcFrName").textContent = best.name;
      document.getElementById("bwcFrWhy").textContent = best.why || "";
      document.getElementById("bwcFrBuy").onclick = function () { openDrawer(best.key); };

      root.querySelectorAll(".bw-roast").forEach(function (card) {
        var isMatch = card.dataset.roast === best.key;
        card.classList.toggle("bw-is-match", isMatch);
        card.classList.toggle("bw-is-dim", !isMatch);
      });
    }

    finder.querySelectorAll(".bw-opt").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var pick = btn.dataset.pick;
        if (step === 0) answers.brew = pick;
        else if (step === 1) answers.take = pick;
        else answers.profile = pick;
        step++;
        if (step >= qs.length) finish(); else show(step);
      });
    });

    document.getElementById("bwcFrAgain").addEventListener("click", function () {
      answers = {}; step = 0; show(0);
      root.querySelectorAll(".bw-roast").forEach(function (c) {
        c.classList.remove("bw-is-match", "bw-is-dim");
      });
    });
  })();

  /* ---------- quick-add drawer ---------- */
  var qa = document.getElementById("bwcQa");
  var qaFt = qa.querySelector(".bw-qa__ft");
  var qaFtHTML = qaFt.innerHTML;          /* pristine footer, restored after an add */
  var qaAdd, qaTotal, qaShip;
  var qaModes = document.getElementById("bwcQaModes");
  var qaModeGrp = document.getElementById("bwcQaModeGrp");
  var current = null;
  var sel = {};
  var mode = "one";
  var lastFocus = null;
  var added = false;

  function bindFooter() {
    qaAdd = document.getElementById("bwcQaAdd");
    qaTotal = document.getElementById("bwcQaTotal");
    qaShip = document.getElementById("bwcQaShip");
    if (qaAdd) qaAdd.addEventListener("click", addToCart);
  }

  function openDrawer(key, wantMode) {
    var r = byKey[key];
    if (!r) return;
    current = r;
    lastFocus = document.activeElement;

    if (added) { qaFt.innerHTML = qaFtHTML; bindFooter(); added = false; }

    document.getElementById("bwcQaImg").src = r.img;
    document.getElementById("bwcQaName").textContent = r.name;
    document.getElementById("bwcQaOrigin").textContent = r.origin || "";

    var bv = baseVariant(r);
    sel = {};
    AXES.forEach(function (a) { sel[a] = bv.opts[a]; });

    AXES.forEach(function (axis) {
      var wrap = qa.querySelector('.bw-qa__opts[data-axis="' + axis + '"]');
      if (!wrap) return;
      wrap.innerHTML = "";
      axisValues(r, axis).forEach(function (val) {
        var b = document.createElement("button");
        b.className = "bw-qa__opt";
        b.type = "button";
        b.dataset.val = val;
        b.textContent = optLabel(axis, val);
        b.setAttribute("aria-pressed", sel[axis] === val ? "true" : "false");
        b.addEventListener("click", function () {
          sel[axis] = val;
          wrap.querySelectorAll(".bw-qa__opt").forEach(function (o) {
            o.setAttribute("aria-pressed", o.dataset.val === val ? "true" : "false");
          });
          refresh();
        });
        wrap.appendChild(b);
      });
    });

    /* "sub" from the Subscribe & Save button means "whatever we lead with",
       which refresh() resolves to the default plan for the chosen variant. */
    mode = wantMode === "sub" ? "sub" : (wantMode || "one");
    qa.classList.add("bw-is-open");
    document.body.classList.add("bw-no-scroll");
    qa.setAttribute("aria-hidden", "false");
    requestAnimationFrame(function () { qa.classList.add("bw-is-shown"); });
    refresh();
    setTimeout(function () { qa.querySelector(".bw-qa__close").focus(); }, 60);
  }

  function closeDrawer() {
    qa.classList.remove("bw-is-shown");
    qa.setAttribute("aria-hidden", "true");
    document.body.classList.remove("bw-no-scroll");
    setTimeout(function () { qa.classList.remove("bw-is-open"); }, 420);
    if (lastFocus) lastFocus.focus();
  }

  function refresh() {
    var v = findVariant(current, sel);
    var plans = plansFor(v);

    /* mode is either "one" or the id of a selling plan, as a string. Changing
       size or grind can land on a variant with different plans, so re-check
       that whatever is selected still exists before drawing. */
    if (!plans.length) { mode = "one"; qaModeGrp.style.display = "none"; }
    else {
      qaModeGrp.style.display = "";
      if (mode !== "one" && !planById(v, +mode)) mode = String(defaultPlan(v).id);
    }

    if (plans.length) {
      qaModes.innerHTML =
        plans.map(function (p) {
          var every = p.name.replace(/\s*subscription$/i, "");
          return '<button class="bw-qa__mode" type="button" data-mode="' + p.id + '"' +
            ' aria-pressed="' + (mode === String(p.id)) + '">' +
            '<span class="bw-qa__radio"></span>' +
            '<span class="bw-t"><b>' + every + ' - save ' + savedPct(v, p) + '%</b>' +
            '<span>Cancel or skip any time</span></span>' +
            '<span class="bw-p">' + money(p.price) + '</span>' +
          '</button>';
        }).join("") +
        '<button class="bw-qa__mode" type="button" data-mode="one" aria-pressed="' + (mode === "one") + '">' +
          '<span class="bw-qa__radio"></span>' +
          '<span class="bw-t"><b>One time</b><span>Just this once</span></span>' +
          '<span class="bw-p">' + money(v.price) + '</span>' +
        '</button>';
      qaModes.querySelectorAll(".bw-qa__mode").forEach(function (b) {
        b.addEventListener("click", function () { mode = b.dataset.mode; refresh(); });
      });
    }

    var chosen = mode === "one" ? null : planById(v, +mode);
    var total = chosen ? chosen.price : (v ? v.price : 0);
    qaTotal.textContent = money(total);

    if (!v || !v.available) {
      qaAdd.disabled = true;
      qaAdd.style.opacity = ".5";
      qaAdd.innerHTML = "Sold out";
    } else {
      qaAdd.disabled = false;
      qaAdd.style.opacity = "";
      qaAdd.innerHTML = 'Add to Cart <span class="bw-arw">→</span>';
    }

    qaShip.textContent = shipLine(total);
  }

  /* Name the flat rate rather than only the gap to free. "Add $51.01 more for
     free shipping" tells someone they are being charged without saying what,
     and an unnamed cost always reads as a bigger one than $8. */
  function shipLine(subtotal) {
    var gap = DATA.shipThreshold - subtotal;
    if (gap <= 0) return "This order ships free";
    if (!DATA.shipFlat) return "Add " + money(gap) + " more for free shipping";
    return moneyShort(DATA.shipFlat) + " flat shipping - add " + money(gap) + " more for free";
  }

  qa.querySelectorAll("[data-bw-qa-close]").forEach(function (b) {
    b.addEventListener("click", closeDrawer);
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && qa.classList.contains("bw-is-open")) closeDrawer();
  });

  /* ---------- add to cart, for real ---------- */
  function addToCart() {
    var v = findVariant(current, sel);
    if (!v || !v.available) return;
    var chosen = mode === "one" ? null : planById(v, +mode);
    var body = { id: v.id, quantity: 1 };
    if (chosen) body.selling_plan = chosen.id;

    qaAdd.disabled = true;
    qaAdd.innerHTML = "Adding...";

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error("cart");
        return res.json();
      })
      .then(function () { return fetch("/cart.js").then(function (r) { return r.json(); }); })
      .then(function (cart) {
        showAdded(cart);
        document.dispatchEvent(new CustomEvent("bwc:cart-updated", { detail: cart }));
      })
      .catch(function () {
        qaAdd.disabled = false;
        qaAdd.innerHTML = "Something went wrong - try again";
      });
  }
  bindFooter();

  function showAdded(cart) {
    added = true;
    qaFt.innerHTML =
      '<div class="bw-qa__total"><span class="bw-l">In your cart</span>' +
        '<span class="bw-v">' + money(cart.total_price) + '</span></div>' +
      '<a class="bw-btn bw-btn--full bw-btn--lg" href="/cart">Go to cart <span class="bw-arw">→</span></a>' +
      '<p class="bw-qa__ship">' + shipLine(cart.total_price) + '</p>' +
      '<button class="bw-finder__again" type="button" style="display:block;margin:12px auto 0" data-bw-keep>Keep shopping</button>';
    qaFt.querySelector("[data-bw-keep]").addEventListener("click", closeDrawer);
  }

  /* ---------- open triggers ---------- */
  root.querySelectorAll("[data-bw-add]").forEach(function (btn) {
    btn.addEventListener("click", function () { openDrawer(btn.dataset.bwAdd); });
  });

  onScroll();
})();
